import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  Pagination,
  PrintableFormatContainerModel, PrintableFormatService
} from 'blg-akaun-ts-lib';
import { AppConfig } from '../../visa';
import { ReplaySubject, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { SubSink } from 'subsink2';

@Component({
  selector: 'app-select-parent-printable',
  templateUrl: './parent-printable-dropdown.component.html',
  styleUrls: ['./parent-printable-dropdown.component.css']
})
export class ParentPrintableDropdownComponent implements OnInit, OnDestroy {
  @Input() txnType = new FormControl();
  @Input() printable = new FormControl();
  @Input() hideNone;
  @Output() printableSelected = new EventEmitter<PrintableFormatContainerModel>();

  selected: PrintableFormatContainerModel;
  private subs = new SubSink();

  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<PrintableFormatContainerModel[]> = new ReplaySubject<PrintableFormatContainerModel[]>(1);
  printableList: PrintableFormatContainerModel[];
  protected _onDestroy = new Subject<void>();
  constructor( private service: PrintableFormatService ) {}

  ngOnInit() {
    
    const paging = new Pagination();
    paging.conditionalCriteria.push({ columnName: 'txn_type', operator: '=', value: this.txnType.toString() });
    this.subs.sink = this.service.getByCriteria(paging, this.apiVisa).subscribe(
      {next: resolve => {
        let noneOption = new PrintableFormatContainerModel();
        this.printableList = resolve.data;
        if(!this.hideNone){
          noneOption.bl_prt_printable_format_hdr.guid = <any> 0;
          noneOption.bl_prt_printable_format_hdr.name = "NONE";
          this.printableList = [noneOption,...resolve.data];
        }

        this.printableList =  this.printableList.filter(p=>!p.bl_prt_printable_format_hdr.guid_parent);
        this.filteredOptions$.next(this.printableList);
        if (this.printable && this.printable.value) {
          this.onSelect(this.printable.value)
        }
      }});
      
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterPrintable(resolve)});
  }

  filterPrintable(search: string) {
    if (!search) {
      
      this.filteredOptions$.next(this.printableList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.printableList.filter(c => c.bl_prt_printable_format_hdr.name.toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  onSelect(guid: string) {
    if (guid) {
      this.printable.patchValue(guid);
      this.selected= this.printableList.find(p => p.bl_prt_printable_format_hdr.guid === guid);
      this.printableSelected.emit(this.selected);
     
    }
  }

  onPatchValue(guid: string) {
    this.service.getByGuid(guid, this.apiVisa).pipe(
      takeUntil(this._onDestroy)
    ).subscribe( resolved => {
      this.printableList = [resolved.data];
      this.filteredOptions$.next([resolved.data]);
      this.onSelect(resolved.data.bl_prt_printable_format_hdr.guid.toString());
    });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

